import styled from "styled-components";
import background from "../ModalInfo/Assets/modalInfoBG.jpg"


export const Modal = styled.div`
    width:100%;
    height:100vh;
    position:absolute;
    top:0;
    left:0;
    z-index:22;
    background-color: rgba(33,33,33,0.55);
    display:flex;
    justify-content:center;
    align-items:center;
`;


export const Container = styled.div`
        background-image: url(${background});
        background-size:cover;
        color:black;
        width:538px;
        height:295px;
        border-radius:20px;
        margin-left:30px;
        margin-right:30px;

    p{
        height: 37px;
        font-size: 14px;
        letter-spacing: 0px;
        line-height: 20px;
        color: #fff;
        font-weight: 300;
        margin-left:30px;
        margin-right:30px;
        margin-bottom:120px;
    }

    h1{
        color:#12d258;
        width: 321px;
        font-size: 15px;
        letter-spacing: 0px;
        line-height: 20px;
        color: #12d258;
        font-weight: bold;
        margin-left:58px;
        margin-right:30px;
    }

    button{
        border:none;
        outline:none;
        right:calc(-100% + 18px);
        top:-12px;
        display:flex;
        position:relative;
        align-items:center;
        cursor: pointer;
        width: 35px;
        height: 35px;
        border-radius: 8px;
        background-color: #4055b1;
        color:#fff;
        font-size:17px;
        justify-content: center;
        font-weight: bold;
    }

    @media screen and (max-width: 543px) {
        height:330px;
    }

`;

export const ContainerExclusao = styled.div`
        background-image: url(${background});
        background-size:cover;
        color:black;
        width:800px;
        height:400px;
        border-radius:20px;
        margin-left:30px;
        margin-right:30px;

    p{
        height: 37px;
        font-size: 14px;
        letter-spacing: 0px;
        line-height: 20px;
        color: #fff;
        font-weight: 300;
        margin-left:30px;
        margin-right:30px;
        margin-bottom:120px;
    }

    h1{
        color:#12d258;
        width: 321px;
        font-size: 15px;
        letter-spacing: 0px;
        line-height: 20px;
        color: #12d258;
        font-weight: bold;
        margin-left: 30px;
        margin-right:30px;
    }

    button{
        border:none;
        outline:none;
        right:calc(-100% + 18px);
        top:-12px;
        display:flex;
        position:relative;
        align-items:center;
        cursor: pointer;
        width: 35px;
        height: 35px;
        border-radius: 8px;
        background-color: #4055b1;
        color:#fff;
        font-size:17px;
        justify-content: center;
        font-weight: bold;
    }

    @media screen and (max-width: 543px) {
        height:330px;
    }

`;

export const Footer = styled.footer`
    display: inline-flex;
    width:100%;
    border-top:solid 1px;
    border-color: #333333;
    margin-top: -13px;

    button{
        width: 64px;
        height: 18px;
        border-radius: 12px;
        background-color: #12d258;
        font-size: 11px;
        left: 24px;
        top: auto;
        justify-content: center;
    }
    P{
        display:flex;
        font-size: 12px;
        color: #12d258;
        text-decoration:underline;
        cursor: pointer;
        padding-left: 10px;
    }

    div{
        display:inline-flex;
        padding-top: 18px;
        margin-left: 38px;
    }

    @media screen and (max-width: 543px) {
        margin-top: 20px;
    }

`;

export const FooterExclusao = styled.footer`
    display: inline-flex;
    width:100%;
    border-top:solid 1px;
    border-color: #333333;
    margin-top: 85px;

    button{
        width: 64px;
        height: 18px;
        border-radius: 12px;
        background-color: #12d258;
        font-size: 11px;
        left: 24px;
        top: auto;
        justify-content: center;
    }
    P{
        display:flex;
        font-size: 12px;
        color: #12d258;
        text-decoration:underline;
        cursor: pointer;
        padding-left: 10px;
    }

    div{
        display:inline-flex;
        padding-top: 18px;
        margin-left: 38px;
    }

    @media screen and (max-width: 543px) {
        margin-top: 20px;
    }

`;